import React, { ReactElement } from 'react';
import Star from './star';
import style from './index.module.css';

export interface RateProps {
  value?: number;
  onChange?: (val: number[]) => void;
  disabled?: boolean;
}

const Rate = (props: RateProps): ReactElement => {
  const { value = 0, onChange } = props;

  const [rating, setRating] = React.useState(
    typeof value == 'number' ? value : 0
  );

  // 如果传入的value改变，更新rating
  React.useEffect(() => {
    setRating(value);
  }, [value]);

  const handleClick = e => {
    if (props.disabled) return;
    setRating(e.target.getAttribute('star-id') || rating);
    onChange && onChange(e.target.getAttribute('star-id') || rating);
  };

  return (
    <div className={style.wrap} onClick={handleClick}>
      {Array.from({ length: 5 }, (v, i) => (
        <Star starId={i + 1} key={i} marked={rating >= i + 1} />
      ))}
    </div>
  );
};

export default React.memo(Rate);
